import DatabaseModel from './DatabaseModel.js';

var RepartoEjecucion = Object.create(DatabaseModel);

RepartoEjecucion.model = 'reparto-ejecucion';

export default RepartoEjecucion;